import React from 'react'
import classes from './Background.module.css'

const Background = props => <div className={
    classes.Background}
    onClick={props.onClick}
    />

    export default Background;